import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  CreateOfficeOpts,
  Office,
  OfficeVisitsSettingsConfig,
  PaginatedResponse,
  SearchOfficeOpts,
  ToggleAssignedVoivodeship,
  UpdateOfficeVisitsSetting,
} from '@interfaces';
import { environment } from '@environment';

@Injectable({
  providedIn: 'root',
})
export class OfficesHttpService {
  private readonly http = inject(HttpClient);

  private API_URL = environment.API_URL;
  private FULL_URL_OFFICES = `${this.API_URL}/offices`;

  public getOfficesSimpleList(): Observable<Office[]> {
    const url = `${this.FULL_URL_OFFICES}`;
    return this.http.get<Office[]>(url);
  }

  public searchOffices(opts: SearchOfficeOpts): Observable<PaginatedResponse<Office>> {
    const url = `${this.FULL_URL_OFFICES}/search`;
    return this.http.post<PaginatedResponse<Office>>(url, opts);
  }

  public getOffice(officeId: string): Observable<Office> {
    const url = `${this.FULL_URL_OFFICES}/${officeId}`;
    return this.http.get<Office>(url);
  }

  public createOffice(opts: CreateOfficeOpts): Observable<Office> {
    const url = `${this.FULL_URL_OFFICES}`;
    return this.http.post<Office>(url, opts);
  }

  public updateOffice(officeId: string, office: CreateOfficeOpts): Observable<Office> {
    const url = `${this.FULL_URL_OFFICES}/${officeId}`;
    return this.http.patch<Office>(url, office);
  }

  public removeOffice(officeId: string): Observable<Office> {
    const url = `${this.FULL_URL_OFFICES}/${officeId}`;
    return this.http.delete<Office>(url);
  }

  public restoreOffice(officeId: string): Observable<Office> {
    const url = `${this.FULL_URL_OFFICES}/${officeId}/restore`;
    return this.http.patch<Office>(url, {});
  }

  public toggleAssignedVovoideship(opts: ToggleAssignedVoivodeship): Observable<Office> {
    const url = `${this.FULL_URL_OFFICES}/${opts.officeId}/assigned-voivodeships`;
    return this.http.patch<Office>(url, opts);
  }

  // Office Visits Settings

  public getOfficeVisitsSettings(officeId: string): Observable<OfficeVisitsSettingsConfig> {
    const url = `${this.FULL_URL_OFFICES}/${officeId}/visits-settings`;
    return this.http.get<OfficeVisitsSettingsConfig>(url);
  }

  public updateOfficeVisitsSettings(officeId: string, payload: UpdateOfficeVisitsSetting): Observable<Office> {
    const url = `${this.FULL_URL_OFFICES}/${officeId}/visits-settings`;
    return this.http.patch<Office>(url, payload);
  }
}
